import { Component, DestroyRef, EventEmitter, inject, Input, Output, SimpleChanges } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, NEVER, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OrderException } from '../../../overview/models/order-exception';
import { OrderExceptionsDetailsService } from '../../services/order-exceptions-details.service';
import { OrderExceptionTableComponent } from '../order-exception-table/order-exception-table.component';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-order-exception-details',
  standalone: true,
  templateUrl: './order-exception-details.component.html',
  imports: [OrderExceptionTableComponent, MatTooltip, NgClass],
  styleUrl: './order-exception-details.component.scss'
})
export class OrderExceptionDetailsComponent {
  @Input() orderExceptionId: string | null = null;
  @Input() isArchived = false;
  @Output() detailsClosed = new EventEmitter();

  orderExceptions: OrderException[] | null = null;
  orderException: OrderException | null = null;
  isBeingWatched = false;

  private orderExceptionsDetailsService = inject(OrderExceptionsDetailsService);
  private destroyRef = inject(DestroyRef);
  private matSnackBar = inject(MatSnackBar);

  ngOnChanges(changes: SimpleChanges) {
    if (changes['orderExceptionId'] && changes['orderExceptionId'].currentValue) {
      this.orderExceptions = null;
      this.orderExceptionsDetailsService
        .getOrderExceptionBy(this.orderExceptionId!, this.isArchived)
        .pipe(
          tap(orderException => {
            this.orderExceptions = [orderException];
            this.orderException = orderException;
            this.isBeingWatched = orderException.watched;
          }),
          catchError(error => {
            this.matSnackBar.open('Could not get the order exception details. Please try again.', 'x');
            console.error(error);
            return NEVER;
          }),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe();
    }
  }

  toggleWatch() {
    this.orderExceptionsDetailsService
      .watched(this.orderExceptionId!, !this.isBeingWatched)
      .pipe(
        tap(() => this.handleSuccess()),
        catchError(error => this.handleError(error)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  private handleSuccess() {
    if (this.isBeingWatched) {
      this.matSnackBar.open('Order exception removed from watch list', 'x', { panelClass: 'snackbar-green' });
    } else {
      this.matSnackBar.open('Order exception added to watch list', 'x', { panelClass: 'snackbar-green' });
    }
    this.isBeingWatched = !this.isBeingWatched;
  }

  private handleError(error: HttpErrorResponse) {
    this.matSnackBar.open('Could not update order exception watch status, please try again later.', 'x');
    console.error(error);

    return NEVER;
  }
}
